











































































import { defineComponent, PropType, computed } from "@vue/composition-api";
import MenuDropdown from "@/components/Molecules/MenuDropdown/index.vue";
import OccCheckbox from "@/components/Atoms/OccCheckbox/index.vue";
import { ApiResponse } from "@/api/types";

type Value = string | number | boolean | object;

type TableColumn = {
  content?: string;
  subContent?: string;
  colspan?: number;
  menuDropDown?: {
    partnerUserId: number;
  };
  config?: {
    isNowrap?: boolean;
  };
  checkbox?: {
    value?: Value;
    targetIds?: Value[];
  };
};
type TableRows = TableColumn[];

interface Props {
  tableHead: TableRows[];
  tableData: TableRows[];
  checkedValues: Value[];
}

export default defineComponent({
  name: "Table",
  components: {
    MenuDropdown,
    OccCheckbox
  },
  emits: ["edit", "delete", "checkAll", "check"],
  props: {
    tableHead: {
      type: Array as PropType<Props["tableHead"]>,
      required: true
    },
    tableData: {
      type: Array as PropType<Props["tableData"]>,
      required: true
    },
    checkedValues: {
      type: Array as PropType<Props["checkedValues"]>,
      default: () => []
    },
    isCheckedAll: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit, root }) {
    const currentPartnerUser = computed<ApiResponse.PartnerUser | undefined>(
      () => root.$store.state.domains.user.partnerUser
    );
    const dropDown = (data: TableColumn) => {
      if (!data.menuDropDown) return [];
      const editMenu = [
        {
          value: `edit/${data.menuDropDown?.partnerUserId}`,
          label: "編集",
          iconName: "Edit"
        }
      ];
      const deleteMenu = [
        {
          value: `delete/${data.menuDropDown?.partnerUserId}`,
          label: "削除",
          iconName: "Delete"
        }
      ];
      if (!currentPartnerUser.value) return editMenu;
      return currentPartnerUser.value.id !== data.menuDropDown.partnerUserId
        ? editMenu.concat(deleteMenu)
        : editMenu;
    };

    const handleClick = (params: string) => {
      const type = params.split("/")[0];
      const partnerUserId = params.split("/")[1];
      if (type === "edit") {
        handleClickEdit(Number(partnerUserId));
      } else if (type === "delete") {
        handleClickDelete(Number(partnerUserId));
      }
    };
    const handleClickEdit = (partnerUserId: number) => {
      emit("edit", partnerUserId);
    };
    const handleClickDelete = (partnerUserId: number) => {
      emit("delete", partnerUserId);
    };

    const isChecked = (value: Value) => {
      return props.checkedValues.includes(value);
    };
    const handleCheckAll = () => {
      emit("checkAll");
    };
    const handleCheck = (value: number) => {
      emit("check", value);
    };

    return {
      currentPartnerUser,
      dropDown,
      handleClick,
      handleClickEdit,
      handleClickDelete,
      isChecked,
      handleCheckAll,
      handleCheck
    };
  }
});
